import React from 'react';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

const READING_OPTIONS = [
  {
    value: 'readings_in_wild',
    title: 'Reading in the Wild',
    description: 'Students explore news freely from the full feed.',
  },
  {
    value: 'readings_in_wild_course_topics',
    title: 'News suggestions - course topics',
    description:
      'We suggest articles matched to your lecture topics each week.',
  },
  {
    value: 'assigned_readings_only',
    title: 'Assigned readings',
    description: 'Articles you specifically assign as links, text, or PDFs.',
  },
];

function ReadingOptionCard({ checked, onToggle, title, description }) {
  return (
    <div
      className={`reading-option-card ${checked ? 'is-selected' : ''}`}
      onClick={onToggle}
    >
      <div
        className={`reading-option-checkbox ${checked ? 'is-selected' : ''}`}
      >
        {checked && (
          <svg
            viewBox="0 0 10 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 4L3.5 6.5L9 1"
              stroke="#fff"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <div>
        <div className="reading-option-title">{title}</div>
        <div className="reading-option-desc">{description}</div>
      </div>
    </div>
  );
}

export default function SyllabusUploadStepReadingOptions({
  value = [],
  onChange,
  onBack,
  onConfirm,
  loading,
}) {
  const toggle = (optionValue) => {
    if (value.includes(optionValue)) {
      onChange(value.filter((v) => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  };

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">
            How would you like students to read?
          </div>
          <p className="syllabus-step-desc mt-1">
            Choose all that apply — you can adjust these per topic later.
          </p>
        </div>
        <div className="section-con">
          {READING_OPTIONS.map((option) => (
            <ReadingOptionCard
              key={option.value}
              checked={value.includes(option.value)}
              onToggle={() => toggle(option.value)}
              title={option.title}
              description={option.description}
            />
          ))}
        </div>
        <div className="syllabus-step-footer">
          <div />
          <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
            {/* <RectangularButton onClick={onBack} disabled={loading}>
              Back
            </RectangularButton> */}
            <RectangularButton
              darkButton
              onClick={onConfirm}
              disabled={loading}
            >
              Continue
            </RectangularButton>
          </div>
        </div>
      </div>
    </div>
  );
}
